export const apiConstants = {
    // campaign_status: "campaignstatus/",
    // campaign_summary: "campaignperformance/",
    campaign_status_php: "analytics_api/campaignstatus.php",
    campaign_summary_php: "analytics_api/campaignsummary.php",
    total_sales_php: "sessettings/totalsales.php",
    category_sales_php: "sessettings/categorysales.php",
	channel_sales_php: "sessettings/channelsales.php"
};